import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useCallback, useContext } from 'react';
import Button from '../components/shared/Button';
import EditorSearchBar from './EditorSearchBar';
import EditorDropwdownReview from './EditorDropwdownReview';
import EditorTimeToLeft from './EditorTimeToLeft';
import FreePdf from '../services/FreePdf';
import useOptions from '../hooks/useOptions';
import EditorContext from '../store/Editor.context';
import { setFinishStep, setReviewStep, setProcessing, setRedactStep } from '../store';
import { EDITOR_STEPS } from '../constants';
import { normalizePayload } from '../utils/normalizePayload';
import toast from '../components/shared/Toasts';

var Navigation = function Navigation(_ref) {
  var refPdf = _ref.refPdf;

  var _useContext = useContext(EditorContext),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  var _useOptions = useOptions(),
      onRedactSuccess = _useOptions.onRedactSuccess,
      onCancel = _useOptions.onCancel;

  var isEditStep = state.activeStep === EDITOR_STEPS.edit;
  var isReviewStep = state.activeStep === EDITOR_STEPS.review;
  var handleNextClick = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _state$changes$presen, payload, data, _payload, _data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!isEditStep) {
              _context.next = 13;
              break;
            }

            if ((_state$changes$presen = state.changes.present) === null || _state$changes$presen === void 0 ? void 0 : _state$changes$presen.length) {
              _context.next = 5;
              break;
            }

            toast.warning({
              description: 'No Redactions Provided.'
            });
            return _context.abrupt("return");

          case 5:
            dispatch(setProcessing('Preparing your document for review...'));
            payload = normalizePayload(state.changes.present, 'review');
            _context.next = 9;
            return FreePdf.reviewPDF(payload);

          case 9:
            data = _context.sent;
            dispatch(setReviewStep(data.getUrl));
            _context.next = 21;
            break;

          case 13:
            if (!isReviewStep) {
              _context.next = 21;
              break;
            }

            dispatch(setProcessing('Preparing your securely redacted document...'));
            _payload = normalizePayload(state.changes.present, 'redact', {
              ForceRasterize: state.forceRasterization
            });
            _context.next = 18;
            return FreePdf.redactPDF(_payload);

          case 18:
            _data = _context.sent;
            dispatch(setFinishStep(_data.getUrl));
            if (onRedactSuccess) onRedactSuccess(_data.getUrl);

          case 21:
            _context.next = 26;
            break;

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](0);
            toast.error({
              description: _context.t0
            });

          case 26:
            _context.prev = 26;
            dispatch(setProcessing(false));
            return _context.finish(26);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 23, 26, 29]]);
  })), [state.activeStep, state.forceRasterization, state.changes.present]);
  return /*#__PURE__*/React.createElement("nav", {
    id: "navigation",
    className: "flex-shrink-0 bg-white border-b-2 flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-7xl mx-auto px-2 grid grid-cols-5 items-center w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-span-1"
  }, isEditStep && /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    disabled: state.processing,
    onClick: function onClick() {
      if (onCancel) onCancel();
    }
  }, /*#__PURE__*/React.createElement("span", null, "Cancel")), isReviewStep && /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    disabled: state.processing,
    onClick: function onClick() {
      return dispatch(setRedactStep);
    }
  }, /*#__PURE__*/React.createElement("span", null, "Edit"))), /*#__PURE__*/React.createElement("div", {
    className: "col-span-3 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-2"
  }, isEditStep && /*#__PURE__*/React.createElement(EditorSearchBar, {
    refPdf: refPdf
  }), isReviewStep && /*#__PURE__*/React.createElement(EditorDropwdownReview, null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EditorTimeToLeft, null))), /*#__PURE__*/React.createElement("div", {
    className: "col-span-1 justify-self-end"
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: state.processing,
    variant: "secondary",
    onClick: handleNextClick
  }, /*#__PURE__*/React.createElement("span", null, "Next")))));
};

export default Navigation;